'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var propTypes = {exports: {}};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret$1 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret$1;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = ReactPropTypesSecret_1;

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

{
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes.exports = factoryWithThrowingShims();
}

var PropTypes = propTypes.exports;

var IntermediaContext = /*#__PURE__*/React__default["default"].createContext(null);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var Action = /*#__PURE__*/function (_PureComponent) {
  _inherits(Action, _PureComponent);

  var _super = _createSuper(Action);

  function Action(props) {
    var _this;

    _classCallCheck(this, Action);

    _this = _super.call(this, props);
    _this.state = {
      emitting: false,
      error: null
    };
    _this.emit = _this.emit.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Action, [{
    key: "emit",
    value: function () {
      var _emit = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var args,
            _this$props,
            intermediaClient,
            domain,
            action,
            batching,
            _args = arguments;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                args = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
                _this$props = this.props, intermediaClient = _this$props.intermediaClient, domain = _this$props.domain, action = _this$props.action, batching = _this$props.batching;

                if (!batching) {
                  _context.next = 6;
                  break;
                }

                intermediaClient.emitBatched(domain, action, args);
                _context.next = 18;
                break;

              case 6:
                this.setState({
                  emitting: true
                });
                _context.prev = 7;
                _context.next = 10;
                return intermediaClient.emit(domain, action, args);

              case 10:
                this.setState({
                  error: null
                });
                _context.next = 17;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](7);
                console.error(_context.t0); // eslint-disable-line no-console

                this.setState({
                  error: _context.t0
                });

              case 17:
                this.setState({
                  emitting: false
                });

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[7, 13]]);
      }));

      function emit() {
        return _emit.apply(this, arguments);
      }

      return emit;
    }()
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var _this$state = this.state,
          emitting = _this$state.emitting,
          error = _this$state.error;
      return children(this.emit, {
        emitting: emitting,
        error: error
      });
    }
  }]);

  return Action;
}(React.PureComponent);

Action.propTypes = {
  children: PropTypes.func.isRequired,
  domain: PropTypes.string.isRequired,
  intermediaClient: PropTypes.shape().isRequired,
  action: PropTypes.string.isRequired,
  batching: PropTypes.bool
};
Action.defaultProps = {
  batching: false
};

function ActionContainer(_ref) {
  var domain = _ref.domain,
      action = _ref.action,
      batching = _ref.batching,
      children = _ref.children;
  return /*#__PURE__*/React__default["default"].createElement(IntermediaContext.Consumer, null, function (_ref2) {
    var intermediaClient = _ref2.intermediaClient;
    return /*#__PURE__*/React__default["default"].createElement(Action, {
      intermediaClient: intermediaClient,
      domain: domain,
      action: action,
      batching: batching
    }, children);
  });
}

ActionContainer.propTypes = {
  action: PropTypes.string.isRequired,
  batching: PropTypes.string,
  children: PropTypes.func.isRequired,
  domain: PropTypes.string.isRequired
};
ActionContainer.defaultProps = {
  batching: false
};

var Authenticator = /*#__PURE__*/function (_PureComponent) {
  _inherits(Authenticator, _PureComponent);

  var _super = _createSuper(Authenticator);

  function Authenticator(props) {
    var _this;

    _classCallCheck(this, Authenticator);

    _this = _super.call(this, props);
    _this.state = {
      authenticating: false,
      authFailed: false,
      isAuthenticated: false,
      loading: true,
      previousAuthToken: false,
      validatedAuthToken: null
    };
    _this.authenticate = _this.authenticate.bind(_assertThisInitialized(_this));
    _this.setAuthToken = _this.setAuthToken.bind(_assertThisInitialized(_this));
    return _this;
  } // eslint-disable-next-line react/sort-comp


  _createClass(Authenticator, [{
    key: "authenticate",
    value: function () {
      var _authenticate = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(accountID, password) {
        var intermediaClient, success, authToken;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                intermediaClient = this.props.intermediaClient;
                this.setState({
                  authenticating: true,
                  authFailed: false,
                  loading: true
                });
                _context.next = 4;
                return intermediaClient.authenticate(accountID, password);

              case 4:
                success = _context.sent;

                if (success) {
                  authToken = intermediaClient.getAuthToken();
                  this.setState({
                    authenticating: false,
                    authFailed: false,
                    isAuthenticated: true,
                    loading: false,
                    validatedAuthToken: authToken
                  });
                } else {
                  this.setState({
                    authenticating: false,
                    authFailed: true,
                    isAuthenticated: false,
                    loading: false,
                    validatedAuthToken: null
                  });
                }

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function authenticate(_x, _x2) {
        return _authenticate.apply(this, arguments);
      }

      return authenticate;
    }()
  }, {
    key: "setAuthToken",
    value: function () {
      var _setAuthToken = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(authToken) {
        var _this$state, authenticating, previousAuthToken, validatedAuthToken, intermediaClient, success;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$state = this.state, authenticating = _this$state.authenticating, previousAuthToken = _this$state.previousAuthToken, validatedAuthToken = _this$state.validatedAuthToken;

                if (!(authToken === validatedAuthToken)) {
                  _context2.next = 5;
                  break;
                }

                this.setState({
                  previousAuthToken: authToken
                });
                _context2.next = 12;
                break;

              case 5:
                if (!(authToken !== previousAuthToken)) {
                  _context2.next = 12;
                  break;
                }

                intermediaClient = this.props.intermediaClient;
                this.setState({
                  authFailed: false,
                  loading: true,
                  previousAuthToken: authToken
                });
                _context2.next = 10;
                return intermediaClient.setAuthToken(authToken);

              case 10:
                success = _context2.sent;

                if (success) {
                  this.setState({
                    isAuthenticated: true,
                    loading: authenticating,
                    validatedAuthToken: authToken
                  });
                } else {
                  this.setState({
                    isAuthenticated: false,
                    loading: authenticating
                  });
                }

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function setAuthToken(_x3) {
        return _setAuthToken.apply(this, arguments);
      }

      return setAuthToken;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          authToken = _this$props.authToken,
          children = _this$props.children;
      var _this$state2 = this.state,
          authenticating = _this$state2.authenticating,
          authFailed = _this$state2.authFailed,
          isAuthenticated = _this$state2.isAuthenticated,
          loading = _this$state2.loading,
          validatedAuthToken = _this$state2.validatedAuthToken;

      if (typeof authToken === 'string') {
        this.setAuthToken(authToken);
      } else if (loading && !authenticating) {
        this.setState({
          loading: false
        });
      }

      return children(this.authenticate, {
        authFailed: authFailed,
        isAuthenticated: isAuthenticated,
        loading: loading,
        newAuthToken: validatedAuthToken
      });
    }
  }]);

  return Authenticator;
}(React.PureComponent);

Authenticator.propTypes = {
  authToken: PropTypes.string,
  children: PropTypes.func.isRequired,
  intermediaClient: PropTypes.shape().isRequired
};
Authenticator.defaultProps = {
  authToken: undefined
};

function AuthenticatorContainer(_ref) {
  var authToken = _ref.authToken,
      children = _ref.children;
  return /*#__PURE__*/React__default["default"].createElement(IntermediaContext.Consumer, null, function (_ref2) {
    var intermediaClient = _ref2.intermediaClient;
    return /*#__PURE__*/React__default["default"].createElement(Authenticator, {
      intermediaClient: intermediaClient,
      authToken: authToken
    }, children);
  });
}

AuthenticatorContainer.propTypes = {
  authToken: PropTypes.string,
  children: PropTypes.func.isRequired
};
AuthenticatorContainer.defaultProps = {
  authToken: undefined
};

function IntermediaProvider(_ref) {
  var client = _ref.client,
      children = _ref.children;
  var memoizedValue = React.useMemo(function () {
    return {
      intermediaClient: client
    };
  });
  return /*#__PURE__*/React__default["default"].createElement(IntermediaContext.Provider, {
    value: memoizedValue
  }, children);
}

IntermediaProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  client: PropTypes.shape().isRequired
};

var Subscription = /*#__PURE__*/function (_PureComponent) {
  _inherits(Subscription, _PureComponent);

  var _super = _createSuper(Subscription);

  function Subscription(props) {
    var _this;

    _classCallCheck(this, Subscription);

    _this = _super.call(this, props);
    _this.state = {
      domainState: null,
      error: null
    };
    return _this;
  }

  _createClass(Subscription, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var _this$props, intermediaClient, domain;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props = this.props, intermediaClient = _this$props.intermediaClient, domain = _this$props.domain;
                _context.prev = 1;
                _context.next = 4;
                return intermediaClient.subscribe(domain, function (domainState) {
                  _this2.setState({
                    domainState: domainState
                  });
                });

              case 4:
                this.subscription = _context.sent;
                _context.next = 11;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](1);
                this.setState({
                  error: _context.t0
                });
                console.error(_context.t0); // eslint-disable-line no-console

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 7]]);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.subscription) {
        this.subscription.close();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var _this$state = this.state,
          domainState = _this$state.domainState,
          error = _this$state.error;
      return children({
        data: domainState,
        loading: !domainState,
        error: error
      });
    }
  }]);

  return Subscription;
}(React.PureComponent);

Subscription.propTypes = {
  children: PropTypes.func.isRequired,
  domain: PropTypes.string.isRequired,
  intermediaClient: PropTypes.shape().isRequired
};

function SubscriptionContainer(_ref) {
  var domain = _ref.domain,
      children = _ref.children;
  return /*#__PURE__*/React__default["default"].createElement(IntermediaContext.Consumer, null, function (_ref2) {
    var intermediaClient = _ref2.intermediaClient;
    return /*#__PURE__*/React__default["default"].createElement(Subscription, {
      intermediaClient: intermediaClient,
      domain: domain
    }, children);
  });
}

SubscriptionContainer.propTypes = {
  children: PropTypes.func.isRequired,
  domain: PropTypes.string.isRequired
};

function useIntermediaClient() {
  var overrideClient = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  var _useContext = React.useContext(IntermediaContext),
      intermediaClient = _useContext.intermediaClient;

  if (overrideClient) {
    return overrideClient;
  }

  if (!intermediaClient) {
    throw new Error("Could not find \"client\" in the context or passed in as a prop.\n      Wrap the root component in an <IntermediaProvider>, or pass an\n      Intermedia Client instance in via props.");
  }

  return intermediaClient;
}

function useAction(domain, action) {
  var batching = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var overrideClient = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var intermediaClient = useIntermediaClient(overrideClient);

  var _useState = React.useState({
    emitting: false,
    error: null
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var emit = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var args,
        _args = arguments;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            args = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};

            if (!batching) {
              _context.next = 5;
              break;
            }

            intermediaClient.emitBatched(domain, action, args);
            _context.next = 16;
            break;

          case 5:
            setState(_objectSpread2(_objectSpread2({}, state), {}, {
              emitting: true
            }));
            _context.prev = 6;
            _context.next = 9;
            return intermediaClient.emit(domain, action, args);

          case 9:
            setState(_objectSpread2(_objectSpread2({}, state), {}, {
              error: null
            }));
            _context.next = 16;
            break;

          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](6);
            setState(_objectSpread2(_objectSpread2({}, state), {}, {
              error: _context.t0
            }));
            console.error(_context.t0); // eslint-disable-line no-console

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[6, 12]]);
  })), []);
  return {
    emit: emit,
    emitting: state.emitting,
    error: state.error
  };
}

/**
 * @typedef {Object} DomainStore
 * @property {{ close: Function }} handle
 * @property {any} previousState
 * @property {Function[]} listeners
 */

/** @type {Object<string, DomainStore>} */
var store = {};
/**
 * Add a listener to a domain.
 *
 * @export
 * @param {string} domainName
 * @param {Function} callback
 * @returns
 */

function addDomainListener(_x, _x2, _x3) {
  return _addDomainListener.apply(this, arguments);
}
/**
 * Close a domain subscription.
 *
 * @export
 * @private
 * @param {string} domainName
 */

function _addDomainListener() {
  _addDomainListener = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(intermediaClient, domainName, callback) {
    var domainStore;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!(typeof callback !== 'function')) {
              _context2.next = 2;
              break;
            }

            throw new Error("Parameter \"callback\" is of type ".concat(_typeof(callback), ". It should be a function"));

          case 2:
            if (!store[intermediaClient.id]) {
              store[intermediaClient.id] = {};
            }

            if (!store[intermediaClient.id][domainName]) {
              _context2.next = 9;
              break;
            }

            domainStore = store[intermediaClient.id][domainName];
            store[intermediaClient.id][domainName] = _objectSpread2(_objectSpread2({}, domainStore), {}, {
              listeners: [].concat(_toConsumableArray(domainStore.listeners), [callback])
            });
            callback(domainStore.previousState);
            _context2.next = 21;
            break;

          case 9:
            store[intermediaClient.id][domainName] = {
              previousState: {},
              listeners: [callback]
            };
            _context2.prev = 10;
            _context2.next = 13;
            return intermediaClient.subscribe(domainName, /*#__PURE__*/function () {
              var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(state) {
                var _store$intermediaClie, previousState, listeners;

                return regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _store$intermediaClie = store[intermediaClient.id][domainName], previousState = _store$intermediaClie.previousState, listeners = _store$intermediaClie.listeners;
                        _context.next = 3;
                        return Promise.all(listeners.map(function (listener) {
                          return listener(state, previousState);
                        }));

                      case 3:
                        store[intermediaClient.id][domainName] = _objectSpread2(_objectSpread2({}, store[intermediaClient.id][domainName]), {}, {
                          previousState: state
                        });

                      case 4:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function (_x9) {
                return _ref.apply(this, arguments);
              };
            }());

          case 13:
            store[intermediaClient.id][domainName].handle = _context2.sent;
            _context2.next = 21;
            break;

          case 16:
            _context2.prev = 16;
            _context2.t0 = _context2["catch"](10);
            delete store[intermediaClient.id][domainName];

            if (Object.keys(store[intermediaClient.id]).length === 0) {
              delete store[intermediaClient.id];
            }

            throw _context2.t0;

          case 21:
            return _context2.abrupt("return", callback);

          case 22:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[10, 16]]);
  }));
  return _addDomainListener.apply(this, arguments);
}

function closeSubscription(_x4, _x5) {
  return _closeSubscription.apply(this, arguments);
}
/**
 * Remove a listener from a domain.
 *
 * @export
 * @param {string} domainName
 * @param {Function} handle
 */


function _closeSubscription() {
  _closeSubscription = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(intermediaClient, domainName) {
    var domainStore;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!(store[intermediaClient.id] && store[intermediaClient.id][domainName])) {
              _context3.next = 12;
              break;
            }

            domainStore = store[intermediaClient.id][domainName];
            _context3.prev = 2;
            _context3.next = 5;
            return domainStore.handle.close();

          case 5:
            _context3.next = 10;
            break;

          case 7:
            _context3.prev = 7;
            _context3.t0 = _context3["catch"](2);
            // eslint-disable-next-line no-console
            console.error("Error while closing subscription to ".concat(domainName, " \n      Error: ").concat(_context3.t0.message, " \n      Trace: ").concat(_context3.t0.stack));

          case 10:
            delete store[intermediaClient.id][domainName];

            if (Object.keys(store[intermediaClient.id]).length === 0) {
              delete store[intermediaClient.id];
            }

          case 12:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[2, 7]]);
  }));
  return _closeSubscription.apply(this, arguments);
}

function removeDomainListener(_x6, _x7, _x8) {
  return _removeDomainListener.apply(this, arguments);
}
/**
 * Close all open subscriptions.
 *
 * @export
 */

function _removeDomainListener() {
  _removeDomainListener = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(intermediaClient, domainName, handle) {
    var domainStore;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (!(store[intermediaClient.id] && store[intermediaClient.id][domainName])) {
              _context4.next = 6;
              break;
            }

            domainStore = store[intermediaClient.id][domainName];
            store[intermediaClient.id][domainName] = _objectSpread2(_objectSpread2({}, domainStore), {}, {
              listeners: domainStore.listeners.filter(function (listener) {
                return listener !== handle;
              })
            });

            if (!(store[intermediaClient.id][domainName].listeners.length === 0)) {
              _context4.next = 6;
              break;
            }

            _context4.next = 6;
            return closeSubscription(intermediaClient, domainName);

          case 6:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _removeDomainListener.apply(this, arguments);
}

/**
 * Subscribe to a domain
 *
 * @typedef {IntermediaClient} Object
 * @param {String} domainName
 * @param {IntermediaClient} [overrideClient=null]
 * @returns {Object}
 */

function useSubscription(domainName) {
  var overrideClient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var intermediaClient = useIntermediaClient(overrideClient);

  var _useState = React.useState({
    data: null,
    error: null,
    loading: true
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var callback = React.useCallback(function (data) {
    return setState(function (prevState) {
      return _objectSpread2(_objectSpread2({}, prevState), {}, {
        data: data,
        error: null,
        loading: false
      });
    });
  }, []);
  React.useEffect(function () {
    function subscribe() {
      return _subscribe.apply(this, arguments);
    }

    function _subscribe() {
      _subscribe = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return addDomainListener(intermediaClient, domainName, callback);

              case 3:
                _context2.next = 9;
                break;

              case 5:
                _context2.prev = 5;
                _context2.t0 = _context2["catch"](0);
                setState(_objectSpread2(_objectSpread2({}, state), {}, {
                  error: _context2.t0,
                  loading: false
                }));
                console.error(_context2.t0); // eslint-disable-line no-console

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 5]]);
      }));
      return _subscribe.apply(this, arguments);
    }

    var promise = subscribe();
    return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return promise;

            case 2:
              _context.next = 4;
              return removeDomainListener(intermediaClient, domainName, callback);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  }, []);
  return state;
}

exports.Action = ActionContainer;
exports.Authenticator = AuthenticatorContainer;
exports.IntermediaProvider = IntermediaProvider;
exports.Subscription = SubscriptionContainer;
exports.useAction = useAction;
exports.useIntermediaClient = useIntermediaClient;
exports.useSubscription = useSubscription;
